import { posthog } from 'posthog-js';
import { LogConsole, getParentDomain } from './jsHelper';

export const TRIMLITE_DOMAIN = 'https://trimlite.com';

export const TEST_DOMAIN = 'www.w3schools.com'; // TO DO: This is only for testing purpose

export const KEY_MAPPINGS = {
  [TRIMLITE_DOMAIN]: 'phc_eLyUgloEionyq15TqwHBEaDHIt5lQh8WEeOak5n4av5',
  [TEST_DOMAIN]: 'phc_eLyUgloEionyq15TqwHBEaDHIt5lQh8WEeOak5n4av5', // TO DO: This is only for testing purpose
};

export const initPostHog = () => {
  const parentDomain = getParentDomain();
  if (!parentDomain) return;
  const url = new URL(parentDomain);
  const hostName = url.hostname;
  const key = KEY_MAPPINGS?.[hostName];
  if (!key) return;
  posthog.init(key, {
    api_host: process.env.REACT_APP_POST_HOG_HOST,
    defaults: '2025-05-24',
    // loaded: (posthogEvent) => {
    //   console.log('PostHog loaded:', posthogEvent);
    // },
    // debug: true, // enables console logs
  });
};

export const trackPostHogEvent = (eventName, params = {}) => {
  const finalParams = {
    ...params,
    time_stamp: Date.now(),
    page_source: window.location.pathname,
  };
  LogConsole('PostHog Event', {eventName, finalParams})
  
  // Posthog
  posthog.capture(eventName, finalParams);
};
